import { ClientsService, ProjectsService } from '@/services';
import ClientInterestsEnum from '@/enums/clientInterests';
import ClientOriginsEnum from '@/enums/clientOrigins';

const INITIAL_STATE = {
  loading: true,
  task: {},
  comments: [],
};

const store = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations: {
    SET_TASK(state, value) {
      state.task = value;
    },

    SET_COMMENTS(state, value) {
      state.comments = value;
    },

    SET_LOADING_TASK(state, value) {
      state.loading = value;
    },

    UPDATE_CURRENT_TASK(state, value) {
      state.task = { ...state.task, ...value };
    },
  },
  actions: {
    async setTaskDetails({ commit, dispatch }, task) {
      commit('SET_LOADING_TASK', true);

      const client = await ClientsService.fetchClientProfile(task.client_id);

      commit('SET_TASK', {
        ...task,
        origin: ClientOriginsEnum.getValue(client.origin),
        interests: client.interests.map((interest) => ClientInterestsEnum.getValue(interest)),
        phone: client.main_phone,
        mobile: client.mobile_phone,
      });

      await dispatch('fetchTaskComments', task.id);

      commit('SET_LOADING_TASK', false);
    },

    async updateCurrentTask({ commit }, task) {
      commit('UPDATE_CURRENT_TASK', task);
    },

    async fetchTaskComments({ commit }, taskId) {
      const comments = await ProjectsService.fetchTaskComments(taskId);

      commit('SET_COMMENTS', comments);
    },

    async createComment({ dispatch, commit, state }, comment) {
      commit('SET_LOADING_TASK', true);

      await ProjectsService.createComment(comment);
      await dispatch('fetchTaskComments', state.task.id);

      commit('SET_LOADING_TASK', false);
    },
  },
};

export default store;
